import { AddRounded, EastRounded, PeopleOutline } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import { size } from "lodash";
import PropTypes from "prop-types";
import { Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Flx from "../../../../../components/layout/Flx";
import LoadingFallback from "../../../../../components/LoadingFallback";
import TitledCard from "../../../../../components/ui/TitledCard";
import LoanBorrowersMinimalTable from "../../LoanDrilldownPropertiesTab/LoanBorrowersMinimalTable";
import { sidebarTypeToggle } from "../../../../../redux/actions/sidebarActions";
import { loanDrilldownSidebarTypes } from "../../../../../constants/enums/loanDrilldownScreenSidebarOptions";

const SummaryTabBorrowersCard = ({ baseUrl }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <TitledCard
      title={`Borrowers (${size(loanDrilldown?.borrowers)})`}
      variant="h3"
      icon={<PeopleOutline />}
      headerEndContent={
        <Tooltip title="Add New Borrower" disableInteractive>
          <IconButton
            size="small"
            onClick={() =>
              dispatch(
                sidebarTypeToggle(loanDrilldownSidebarTypes.ADD_BORROWER)
              )
            }
            sx={{ position: "absolute", right: 16, top: 16 }}
          >
            <AddRounded className="thin" />
          </IconButton>
        </Tooltip>
      }
      cardSx={{ flexBasis: "400px", flexGrow: 1, flexShrink: 0 }}
      bodySx={{ pb: 0 }}
      spl
      spr
      spb
    >
      <Suspense fallback={<LoadingFallback />}>
        <LoanBorrowersMinimalTable
          height={"200px"}
          rowData={loanDrilldown?.borrowers}
        />
      </Suspense>
      <Flx end fw sx={{ p: 2 }}>
        <Button
          variant="text"
          onClick={() => navigate(`${baseUrl}/borrowers`)}
          endIcon={<EastRounded className="thin" />}
        >
          Go to Borrowers
        </Button>
      </Flx>
    </TitledCard>
  );
};

SummaryTabBorrowersCard.propTypes = {
  baseUrl: PropTypes.string.isRequired,
};

export default SummaryTabBorrowersCard;
